import Detailview from './[akl]/index';

export { getServerSideProps } from './[akl]/index';

// eslint-disable-next-line import/no-default-export
export default Detailview;
